import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  newMessageNotification: false,
};

export const TicketSlice = createSlice({
  name: "ticket",
  initialState,
  reducers: {
    setNewMessageNotification: (state, action) => {
      state.newMessageNotification = action.payload;
    },
  },
});

export const { setNewMessageNotification } = TicketSlice.actions;

export default TicketSlice.reducer;
